export default __webpack_public_path__ + "static/media/TaggiD-Terms-of-Service.cdd8c381.pdf";